module.exports = __webpack_public_path__ + "img/Operations.9a7a7514.svg";